export default "__VITE_ASSET__TDC_ZxgA__"